import { Card, CardContent } from "../../../../@/components/ui/card";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../@/components/ui/table";
import { Tabs, TabsContent } from "../../../../@/components/ui/tabs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { setSelectedOrderId } from "store/OrdersSlice";
import { fetchLeadList } from "store/leadTemplate";
import { ScrollArea } from "../../../../@/components/ui/scroll-area";
import NoDataComponent from "./leadTableComponents/NoLeadDataComponent";
import TablePaginationComponent from "./leadTableComponents/LeadTablePaginationComponent";
import LeadTableRowComponent from "./leadTableComponents/LeadTableRowComponent";
import LeadHeaderComponent from "./leadTableComponents/LeadHeaderComponent";
import { fetchLeadsList } from "store/LeadsSlice";

export default function LeadTable({ preserveState = false }) {
  const dispatch = useDispatch<AppDispatch>();
  const leadsList = useSelector(
    (state: RootState) => state.businessLeads.leads
  );
  const leadFields = useSelector(
    (state: RootState) => state.lead.selectedFieldsLeadTab
  );

  const selectedLeadTemplateId = useSelector(
    (state: RootState) => state.lead.selectedTemplateIdLeadTab
  );

  console.log("ooo", selectedLeadTemplateId);
  console.log("ooooo", leadFields);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const leadStatus = useSelector(
    (state: RootState) => state.businessLeads.status
  );
  const [leadTime, setLeadTime] = useState(() =>
    preserveState ? localStorage.getItem("leadTime") || "all" : "all"
  );
  const [leadTemplateId, setLeadTemplateId] = useState(selectedLeadTemplateId || "all");

  useEffect(() => {
    setLeadTemplateId(selectedLeadTemplateId || "all");
  }, [selectedLeadTemplateId]);

  const [selectedStatus, setSelectedStatus] = useState(() =>
    preserveState ? localStorage.getItem("selectedLeadStatus") || "all" : "all"
  );
  const [currentPage, setCurrentPage] = useState(() =>
    preserveState ? parseInt(localStorage.getItem("currentLeadPage") || "1") : 1
  );

  console.log("businessss leadsss...", leadsList);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [leadTemplates, setLeadTemplates] = useState<any[]>([]);
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
  const business = useSelector((state: RootState) => state.auth.business);

  const totalPages = useSelector(
    (state: RootState) => state.businessLeads.totalPages
  );
  console.log("Leads:", leadsList.length, leadsList);
  console.log("Total Pages:", totalPages);

  useEffect(() => {
    if (preserveState) {
      localStorage.setItem("leadTime", leadTime);
      localStorage.setItem("leadTemplateId", leadTemplateId);
      localStorage.setItem("selectedLeadStatus", selectedStatus);
      localStorage.setItem("currentLeadPage", currentPage.toString());
    }
  }, [leadTime, selectedStatus, currentPage, preserveState, leadTemplateId]);

  useEffect(() => {
    dispatch(
      fetchLeadsList({
        time: leadTime,
        template_id: leadTemplateId,
        status: selectedStatus,
        page: currentPage,
      })
    );
  }, [dispatch, leadTime, selectedStatus, currentPage, leadTemplateId]);

  useEffect(() => {
    if (business) {
      dispatch(fetchLeadList({ business })).then((response: any) => {
        setLeadTemplates(response.payload);
      });
    }
  }, [dispatch, business]);

  const handleTimeChange = (newTime: string) => {
    setLeadTime(newTime);
    if (!preserveState) {
      setCurrentPage(1);
    }
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      if (preserveState) {
        localStorage.setItem("scrollPosition", window.scrollY.toString());
      }
    }
  };

  const handleCheckboxChange = (status: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedStatus(status);
    } else {
      setSelectedStatus("all");
    }
  };

  const handleRowClick = (orderId: string) => {
    setSelectedRowId(orderId);
    dispatch(setSelectedOrderId(orderId));
  };

  return (
    <div className="flex w-full flex-col ">
      <div className="flex flex-col sm:gap-4 sm:py-4 sm:pl-2 sm:pr-2">
        <main className="flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8 lg:grid-cols-3 xl:grid-cols-3">
          <div className="grid auto-rows-max items-start gap-4 md:gap-8 lg:col-span-2">
            <Tabs defaultValue="all">
              <div className="flex items-center">
                <LeadHeaderComponent
                  orderTime={leadTime}
                  handleTimeChange={handleTimeChange}
                  selectedStatus={selectedStatus}
                  handleCheckboxChange={handleCheckboxChange}
                  orderLength={leadsList.length}
                />
              </div>
              <TabsContent value={leadTime}>
                <Card x-chunk="dashboard-05-chunk-3">
                  <CardContent className="p-0">
                    <div className="relative">
                      <Table className="table-fixed">
                        <TableHeader>
                          <TableRow>
                            <TableHead className="w-[5vw]"></TableHead>
                            <TableHead>Lead Template Name</TableHead>

                            <TableHead className=" ">Status</TableHead>
                            {leadFields.map((field) => (
                              <TableHead
                                key={field.id}
                                className="hidden md:table-cell"
                              >
                                {field.name}
                              </TableHead>
                            ))}
                          </TableRow>
                        </TableHeader>
                      </Table>
                      <ScrollArea className="h-[59vh]">
                        <Table className="table-fixed">
                          <TableBody>
                            {leadsList.length === 0 ? (
                              <>
                                <NoDataComponent />
                              </>
                            ) : (
                              leadsList.map((lead, index) => (
                                <LeadTableRowComponent
                                  lead={lead}
                                  currentPage={currentPage}
                                  index={index}
                                  isSelected={selectedRowId === lead._id}
                                  onClick={() => handleRowClick(lead._id)}
                                />
                              ))
                            )}
                          </TableBody>
                        </Table>
                      </ScrollArea>
                    </div>
                  </CardContent>
                </Card>
                <div className="flex justify-center mt-4">
                  <TablePaginationComponent
                    currentPage={currentPage}
                    totalPages={totalPages}
                    handlePageChange={handlePageChange}
                    preserveState={preserveState}
                  />
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </main>
      </div>
    </div>
  );
}
